import React from 'react'
import RSelect from 'react-select'
import styled from 'styled-components'

import { Trad } from './Trad'
import { inputStyle } from './Input'

const nullFunc = () => null
const defautGetValue = (o) => o && o.value
// adapt
// We define our own select to mutualize behaviours here. We probably won't need to import the real Select anywhere else
export const Select = ({
  value,
  placeholder = 'pickPlaceholder',
  onChange,
  disabled,
  translate = false,
  translatePlaceholder = true,
  getOptionValue = defautGetValue,
  ...rest
}) => {
  const valueAmongOptions = rest.options.find((elem) => getOptionValue(elem) === value) || null
  const handleChange = (option, ...rest) => {
    onChange(getOptionValue(option), ...rest)
  }

  const props = {}
  if (translate) {
    props.getOptionLabel = (o) => <Trad id={o.label} />
  }
  if (placeholder) {
    props.placeholder = translatePlaceholder ? <Trad id={placeholder} /> : placeholder
  }
  if (disabled) {
    props.components = { DropdownIndicator: nullFunc, IndicatorSeparator: nullFunc }
  }

  return (
    <CustomSelect
      classNamePrefix="react-select"
      getOptionValue={getOptionValue}
      value={valueAmongOptions}
      onChange={handleChange}
      isDisabled={disabled}
      disabled={disabled}
      {...props}
      {...rest}
    />
  )
}

const CustomSelect = styled(RSelect)`
  & .react-select__{
    &control{
      ${inputStyle.main}
      padding: 0;
      border-radius: 0;
      &--is-focused{
        ${inputStyle.focus}
        box-shadow: none;
      }
    }
    &single-value {
      &--is-disabled{
        ${inputStyle.disabled}
      }
    }
    &placeholder{
      ${inputStyle.placeholder}
    }
    &value-container{
      padding-left: 0;
    }
  }
`
